import { Component, OnInit } from '@angular/core';
import { ICountDown, ILayoutSettings, IPageContent } from '@app/feature/store-editor/components/layout/store-editor.interface';
import IStoreGetDetailsInterface = namespace.IStoreGetDetailsInterface;
import { ActivatedRoute, Route, Router } from '@angular/router';
import { CommonService } from '@app/shared/services/common/common.service';

@Component({
  selector: 'app-store-homepage',
  templateUrl: './store-homepage.component.html',
  styleUrls: ['./store-homepage.component.css']
})
export class StoreHomepageComponent implements OnInit {

  layoutSettings: ILayoutSettings = {
    maxWidth: 1224,
    color: '#1fb999',
    header: {
      logo: '/assets/img/Merch-Loop4.png',
      bgColor: 'rgb(255 255 255)',
      colorLink: '#1fb999',
      paddingOnSides: 10,
      IsDefaultLogo: true
    },
    footer: {
      logo: '/assets/img/Merch-Loop4.png',
      bgColor: 'rgb(255 255 255)',
      colorLink: '#1fb999',
      paddingOnSides: 10,
      IsDefaultLogo: true
    }
  };
  pageContent: IPageContent[] = [
  ];
  storeNameUrl: string;
  constructor(private commonService: CommonService,
    private activatedRoute: ActivatedRoute, private route: Router) {
    this.activatedRoute.params.subscribe(params => {
      this.storeNameUrl = params['storename'];
    });
  }

  ngOnInit() {
    this.getDesignSetting();
  }

  coder() {
    return {
      decode: function (data: string): { layoutSettings: any, pageContent: any } {
        try {
          return JSON.parse(data);
        } catch (e) {
          return null;
        }
      },
      encoder: function (layoutSettings: any, pageContent: any) {
        return JSON.stringify({ layoutSettings, pageContent });
      }
    };
  }

  getDesignSetting() {
    this.commonService.getStoreByName(this.storeNameUrl).subscribe((res: IStoreGetDetailsInterface) => {
      if (res.StatusCode == 200) {
        localStorage.setItem("storeId", res.Data.ResponseData.StoreId.toString());
        localStorage.setItem("storeUrl", this.storeNameUrl);
        const design = this.coder().decode(res.Data.ResponseData.DesignSetting);
        if (design) {
          this.layoutSettings = design.layoutSettings;
          this.pageContent = design.pageContent;
        }
      }
      else if (res.StatusCode == 405) {
        this.route.navigate(['/404storenotonline']);
      }
      else if (res.StatusCode == 204) {
        this.route.navigate(['/storeofflineW9S']);
      }
    }, (err: any) => {
        this.route.navigate(['/404storenotonline']);
     // this.loader.hide();
      //this.errorhandlerService.handleError(err);
    });
    
  }
}
